import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Case, User } from "pwapi";

import { requestScreen } from "shared/actions/caseDetailActions";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import { DialogEnum } from "./dialogs/Dialog";
import { isFinalized, isScreened } from "./dialogs/utils";

const RequestScreenButton = ({
  caseDetailObject,
  slideId,
  currentUser,
  dialog,
  setDialog,
}: {
  caseDetailObject: CaseDetailState;
  slideId?: number;
  currentUser?: User;
  dialog?: DialogEnum | null;
  setDialog?: Function;
}) => {
  const dispatch = useDispatch();

  const [screenerRequested, setScreenerRequested] = useState<boolean>(false);
  useEffect(() => {
    setScreenerRequested(false); // Get the button unstuck after Next Case
  }, [caseDetailObject.id]);

  const waitingForScreening =
    screenerRequested || caseDetailObject.is_screening;

  const allViewed = caseDetailObject.slides.every(
    // Slide was previously viewed OR is the one they're looking at right now
    (s) => s.was_previously_viewed || s.id === slideId
  );

  /*
    We check for currentUser alone first to make sure that we don't
    accidentally undefined === undefined

    If the current user is the active assignment, display the button
    If the current user is NOT the active assignment, but the case is in screening,
    display the button (it will read Screen Requested)
  */
  return caseDetailObject.status !== Case.status.LIS_PENDING &&
    !isFinalized(caseDetailObject) &&
    currentUser?.id &&
    (!caseDetailObject.is_screening ||
      caseDetailObject.finalize_assignment?.id === currentUser.id) &&
    (caseDetailObject.active_assignment?.id === currentUser.id ||
      caseDetailObject.ordering_doctor?.id === currentUser.id ||
      waitingForScreening) ? (
    <button
      className={classNames(
        "Button",
        waitingForScreening ? "Button--white" : "Button--grey"
      )}
      disabled={!allViewed}
      onClick={() => {
        dialog?.includes("diagnosis") && setDialog && setDialog(null);
        if (!waitingForScreening) {
          dispatch(requestScreen(caseDetailObject.id));
          setScreenerRequested(true);
        }
      }}
      style={waitingForScreening ? { cursor: "default" } : undefined}
    >
      {waitingForScreening
        ? "Screen Requested"
        : isScreened(caseDetailObject.case_diagnosis)
        ? "Rescreen"
        : "Request Screen"}
    </button>
  ) : null;
};

export default RequestScreenButton;
